<template>
	<div class="container">
		<div v-if="DetailData().status == 1">
			<div class="row clearfix">
				<div class="column full">
					<h3 style="text-align: left;">{{ DetailData().title }}</h3>
					<div class="iv2-news-detail__subtitle">
						<p>{{ DetailData().created | moment }}</p>
						<p class="iv2-news-detail__label">{{ DetailData().category_name }}</p>
					</div>
				</div>
			</div>

			<div class="row clearfix">
				<div class="column full">
					<div class="spacer height-40"></div>
				</div>
			</div>

			<div v-html="DetailData().body"></div>

			<div class="row clearfix">
				<div class="column full" data-noedit>
					<div class="spacer height-80"></div>
				</div>
			</div>
			<div class="row clearfix">
				<div class="column full" style="margin: 0 auto;">
					<div style="text-align: center;">
						<span>
							<router-link
								to="/news"
								class="theme__main-btn is-btn is-btn-ghost2 is-upper"
								style="border: 0; letter-spacing: 2px; max-width: 100%; width: 300px; padding-top: 15px; padding-bottom: 15px;"
							>{{ btn_text }}</router-link>
						</span>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment";
export default {
	props: ["news"],

	data() {
		return {
			btn_text: "一覧に戻る"
		};
	},

	created: function() {
		this.DetailData();
	},

	methods: {
		DetailData() {
			const dataId = parseInt(this.$route.params.id);
			const data = this.news.detail.find(items => items.id == dataId);
			return data;
		}
	},

	filters: {
		moment: function(created) {
			return moment(created).format("YYYY年MM月DD日");
		}
	}
};
</script>

<style lang="scss">
.iv2-news-detail__subtitle {
	display: flex;
	.iv2-news-detail__label {
		padding: 0 20px;
		margin: 15px 20px;
		border: 1px solid;
	}
}
</style>